import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlayContent",
  role: "dialog",
  "aria-modal": "true"
}

import { Icon } from '@components';


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalOverlay',
  props: {
    isOpen: { type: Boolean },
    showCloseBtn: { type: Boolean },
    closeCallback: { type: Function }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showCloseBtn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "closeBtn",
              "aria-label": "close overlay",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeCallback && _ctx.closeCallback(...args)))
            }, [
              _createVNode(_unref(Icon), {
                "icon-name": "close",
                lg: ""
              })
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ]))
    : _createCommentVNode("", true)
}
}

})